import { render } from "./patch.vue?vue&type=template&id=70363ed2&scoped=true"
import script from "./patch.vue?vue&type=script&lang=js"
export * from "./patch.vue?vue&type=script&lang=js"

import "./patch.vue?vue&type=style&index=0&id=70363ed2&lang=scss&scoped=true"

import exportComponent from "D:\\GitLocal\\mvs-sys\\mvsui-user\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70363ed2"]])

export default __exports__